import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IRuleValidationResult } from '@cbridge-packages/rule';
import { IPriceFilteringRule } from './priceFilteringRule.interface';

export namespace PriceFilteringRuleAction {
  const actionCreator = actionCreatorFactory('PriceFilteringRule');

  export const reload = actionCreator('RELOAD');
  export const loadList = actionCreator.async<void, IPriceFilteringRule[], IApiErrorParams>('LOAD_LIST');
  export const update = actionCreator.async<IPriceFilteringRule[], IRuleValidationResult[], IApiErrorParams>('UPDATE');
  export const validate = actionCreator.async<IPriceFilteringRule[], IRuleValidationResult[], IApiErrorParams>('VALIDATE');
  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
